import Colors from "../../core/Colors";
import { floodFill } from "../helpers";
import { ComponentF } from "../ui";
import { handleKeyOnClick } from "./keyOnClick";

export const ButtonComp: ComponentF<{
  title: string;
  keys: string | string[];
  showKey: boolean;
  onClick: () => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ hover: false });
  floodFill(C.display, C.bounds, state.hover ? "#45538f" : Colors.B_GREY_1);
  let x = C.bounds.x;
  if (props.showKey) {
    C.display.drawOver(
      x,
      C.bounds.y,
      Array.isArray(props.keys) ? props.keys[0] : props.keys,
      Colors.RED_4,
      null
    );
    x += 2;
  }

  for (let i = 0; i < props.title.length; i++) {
    C.display.drawOver(
      i + x,
      C.bounds.y,
      props.title[i],
      Colors.B_GREY_5,
      null
    );
  }
  C.handlers.hover = () => {
    setState({ hover: true });
  };
  C.handlers.out = () => {
    setState({ hover: false });
  };

  C.handlers.press = () => {
    props.onClick();
  };
  handleKeyOnClick(C, props);
};
